import React from "react";

import DocumentStore from "../../../document/DocumentStore";
import { COMMANDS } from "../../../document/commands";
import CustomCodePanel from "./CustomCodePanel";
import GoogleAnalytics from "./GoogleAnalytics";
import GoogleTagManager from "./GoogleTagManager";
import MetaPixel from "./MetaPixel";
import BDOW from "./BDOW";
import {
  TAB_INTEGRATIONS,
  VIEW_BDOW,
  VIEW_FACEBOOK_APP_ID,
  VIEW_GOOGLE_ANALYTICS,
  VIEW_GOOGLE_TAG_MANAGER,
  VIEW_META_PIXEL,
  VIEW_TABS,
} from "../../../stores/SiteSettingsStore";
import SiteSettingsActions from "../../../actions/SiteSettingsActions";
import FacebookAppId from "./FacebookAppId";

const Integrations = ({ globalCodeData, siteSettings, onChange, selectedChildTab }) => {
  const _onPropChange = (propInfo) => {
    DocumentStore.dispatch({
      type: COMMANDS.UPDATE_GLOBAL_CODE,
      payload: selectedGlobalCodeData.set(propInfo.name, propInfo.value),
    });
  };
  const selectedGlobalCodeData = globalCodeData?.get(selectedChildTab);

  const _onDeleteCustomCode = () => {
    const codeId = selectedGlobalCodeData.get("id");
    SiteSettingsActions.changeView("google-analytics", TAB_INTEGRATIONS);
    DocumentStore.dispatch({ type: COMMANDS.REMOVE_GLOBAL_CODE, payload: codeId });
  };

  const getTabContent = (tabId) => {
    switch (tabId) {
      case VIEW_BDOW:
        return <BDOW siteSettings={siteSettings} onChange={onChange} />;
      case VIEW_GOOGLE_ANALYTICS:
        return <GoogleAnalytics siteSettings={siteSettings} onChange={onChange} />;
      case VIEW_GOOGLE_TAG_MANAGER:
        return <GoogleTagManager siteSettings={siteSettings} onChange={onChange} />;
      case VIEW_META_PIXEL:
        return <MetaPixel siteSettings={siteSettings} onChange={onChange} />;
      case VIEW_FACEBOOK_APP_ID:
        return <FacebookAppId siteSettings={siteSettings} onChange={onChange} />;
      default:
        return (
          <CustomCodePanel
            onPropChange={_onPropChange}
            selectedGlobalCodeData={selectedGlobalCodeData}
            onDeleteCustomCode={_onDeleteCustomCode}
          />
        );
    }
  };

  return getTabContent(selectedChildTab === VIEW_TABS ? "google-analytics" : selectedChildTab);
};

export default Integrations;
